export default {
  sorry: 'Sorry',
  sorryClass: 'Sorry, we could not find ',
  weFound: 'we found ',
  noResults: 'no results',
  fares: ' fares',
  theseDates: ' on these dates.',
  matchingSearch: 'matching your search.',
}
